import { useState } from 'react';
import { useCreateLocation, useUpdateLocation, useSelectedPlant } from '../../../../hooks';

import { SetupDrawer } from '../../../atoms';
import { TextInput } from '@pella/sash-framework';

/**
 * Component for the Location Drawer.
 * @param {Local.SetupDrawerProps} props - Component props
 */
export const LocationDrawer = ({ open, close, data, selectedId }) => {
  const { selectedPlant } = useSelectedPlant();
  const { mutate: createLocation, isPending: isCreating } = useCreateLocation();
  const { mutate: updateLocation, isPending: isUpdating } = useUpdateLocation();

  const [formChanges, setFormChanges] = useState(
    /** @type {Partial<Pella.ProductionRequestAPI.CreateLocationInput>} */ ({}),
  );

  const currentForm = selectedId ? data?.find((record) => record.id === selectedId) : { active: true };

  // Combine initial data with form changes to get the current location state
  const location = { ...currentForm, ...formChanges };
  const isEdit = Boolean(selectedId);

  /** Handler to reset form and close drawer */
  const handleClose = () => {
    setFormChanges({});
    close();
  };

  /** handler for form submission */
  const handleSubmit = () => {
    // Ensure all required fields are defined before mutation
    if (!isEdit) {
      const input = {
        plantId: selectedPlant,
        /* v8 ignore start */
        active: location.active ?? true,
        description: location.description || '',
        /* v8 ignore stop */
      };
      createLocation(input, { onSuccess: handleClose });
    } else {
      const id = selectedId;
      const input = {
        description: location.description,
        active: location.active,
      };
      updateLocation({ id, input }, { onSuccess: handleClose });
    }
  };

  const hasRequiredFields = Boolean(location.description?.trim());
  const isLoading = isCreating || isUpdating;

  const disableSubmit = !hasRequiredFields || isLoading;
  const disableForms = !location.active;

  return (
    <SetupDrawer
      open={open}
      close={handleClose}
      title='Location'
      isEdit={isEdit}
      isCopy={false}
      active={Boolean(location.active)}
      onActiveChange={() => setFormChanges((prev) => ({ ...prev, active: !location.active }))}
      onSubmit={handleSubmit}
      disableSubmit={disableSubmit}
    >
      <TextInput
        id='locationNameInput'
        labelText='Location Name'
        disabled={disableForms}
        maxLength={50}
        required={Boolean(!location.description)}
        value={location.description || ''}
        onChange={(e) => setFormChanges((prev) => ({ ...prev, description: e.target.value }))}
      />
    </SetupDrawer>
  );
};
